import ProjectWorkspacePage from "../../shared/projectWorkspace/ProjectWorkspacePage";

const SolarentOperatorProjectWorkspacePage = () => (
  <ProjectWorkspacePage configKey="solarentOperator" />
);

export default SolarentOperatorProjectWorkspacePage;
